var React = require('react');

function Next (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.1 12.25a.6.6 0 00.37-.14l5.8-4.66a.6.6 0 000-.93L4.48 1.9a.6.6 0 00-.74.93l5.19 4.17-5.22 4.2a.6.6 0 00.38 1.06z"}));
}

Next.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = Next;

Next.default = Next;
